<template>
<div>
  <form class="tui ui form" @submit.prevent="authenticate()">
    <div v-if="hasError" class="wrap-error">
      <t-icon class="icon" :icon="[ 'fas', 'exclamation-circle' ]" />
      <p>E-mail ou senha incorretos.</p>
    </div>
    <div class="tui form-field" :class="{'error':hasError}">
      <label for="email">E-mail</label>
      <input id="email" v-model="form.auth.email" name="email" type="email" placeholder="E-mail" required />
    </div>

    <div class="tui form-field" :class="{'error':hasError}">
      <label for="password">Senha</label>
      <input id="password" v-model="form.auth.password" name="password" type="password" placeholder="•••••••••••" required />
    </div>

    <div class="tui form-field right aligned">
      <button type="submit" :class="`tui ui button primary ${isLoading ? 'loading' : ''} ${isLoading ? 'disabled' : ''}`" :disabled="isLoading">
        Entrar
      </button>
    </div>
  </form>
</div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { getOrganizationInfo } from '@/graphl/queries/organization'
const { NODE_ENV } = process.env
const isProduction = NODE_ENV === 'production'

export default {
  data () {
    return {
      form: {
        auth: {
          email: '',
          password: ''
        }
      }
    }
  },

  computed: {
    ...mapState({
      isLoading: ({ auth }) => auth.status === 'loading',
      hasError: ({ auth }) => auth.status === 'error'
    })
  },

  mounted () {
    if (!isProduction) {
      this.form.auth = {
        email: 'direct_call@email.com',
        password: 'P7eMycofsCufB7VQ'
      }
    }
  },

  methods: {
    ...mapActions(['authenticateUser', 'setOrganization']),

    authenticate () {
      this.authenticateUser(this.form.auth)
        .then(() => {
          getOrganizationInfo().then(res => {
            if (res) {
              const { organization } = res.data
              this.setOrganization(organization)
            }
          }).catch(err => { throw new Error(err) })
        })
        .then(() => this.$router.push('/home'))
        .catch(err => {
          this.$log.error('error', err)
        })
      }
  }
}
</script>

<style lang="scss" scoped>
@import "@/assets/css/colors.scss";
.wrap-error {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 40px;
  background: $red-500;
  color: $white-100;
  border-radius: 3px;
  margin-bottom: 20px;

  .icon {
    margin-right: 10px;
  }
}
</style>
